/**
 * Custom error classes for the bridge. Exposed at the package root so callers
 * can use `instanceof` checks instead of string-matching on `error.message`.
 */
export class BridgeTimeoutError extends Error {
    name = 'BridgeTimeoutError';
    constructor(message = 'Bridge request timed out') {
        super(message);
    }
}
export class BridgeDisposedError extends Error {
    name = 'BridgeDisposedError';
    constructor(message = 'Bridge was disposed before the request resolved') {
        super(message);
    }
}
/** Thrown when the host responds with `ok: false`. Carries the host's error string. */
export class BridgeRejectedError extends Error {
    name = 'BridgeRejectedError';
    constructor(message) {
        super(message);
    }
}
//# sourceMappingURL=errors.js.map